import API from "../../../../../global/api";


export const requestAddLevelTwo = () => {
    return {
        type: "REQUEST_ADD_LEVELTWO",
    };
};
export const successAddLevelTwo = (data) => {
    return {
        type: "SUCCESS_ADD_LEVELTWO",
        payload: data,
    };
};
export const errorAddLevelTwo = () => {
    return {
        type: "ERROR_ADD_LEVELTWO",
    };
};
export const AddLevelTwoApi = (data, handleVisible, handleDangerVisible) => {
    return (dispatch) => {
        dispatch(requestAddLevelTwo());
        API.post(`/levelTwo/add_levelTwo`, data).then((res) => {
            dispatch(successAddLevelTwo(data));
            handleVisible(res.data.message);
        }).catch((error) => {
            dispatch(errorAddLevelTwo());
            handleDangerVisible(error.response.data.message);
        })
    };
};


export const requestGetLevelTwo = () => {
    return {
        type: "REQUEST_GET_LEVELTWO",
    };
};
export const successGetLevelTwo = (data) => {
    return {
        type: "SUCCESS_GET_LEVELTWO",
        payload: data,
    };
};
export const errorGetLevelTwo = () => {
    return {
        type: "ERROR_GET_LEVELTWO",
    };
};
export const GetLevelTwoApi = () => {
    return (dispatch) => {
        dispatch(requestGetLevelTwo());
        API.get(`/levelTwo`).then((res) => {
            let getData = res.data;
            dispatch(successGetLevelTwo(getData));
        }).catch((error) => {
            dispatch(errorGetLevelTwo());
        })
    };
};


export const requestGetLevelTwoWithLevelOneID = () => {
    return {
        type: "REQUEST_GET_LEVELTWO_WITH_LEVELONE_ID",
    };
};
export const successGetLevelTwoWithLevelOneID = (data) => {
    return {
        type: "SUCCESS_GET_LEVELTWO_WITH_LEVELONE_ID",
        payload: data,
    };
};
export const errorGetLevelTwoWithLevelOneID = () => {
    return {
        type: "ERROR_GET_LEVELTWO_WITH_LEVELONE_ID",
    };
};
export const GetLevelTwoWithLevelOneIDApi = (levelOneId) => {
    return (dispatch) => {
        dispatch(requestGetLevelTwoWithLevelOneID());
        API.get(`/levelTwo/get_by_levelOne/${levelOneId}`).then((res) => {
            let getData = res.data;
            dispatch(successGetLevelTwoWithLevelOneID(getData));
        }).catch((error) => {
            dispatch(errorGetLevelTwoWithLevelOneID());
        })
    };
};